<div class="invoices-page">
    <app-invoice-header
      [(searchQuery)]="searchQuery"
      [eventTypes]="allEventTypes"
      [invoiceSiteNames]="allSiteNames"
      (monthRangeChange)="onMonthRangeChange($event)"
      (siteFilterChange)="onSiteFilterChange($event)"
      (eventTypeFilterChange)="onEventTypeFilterChange($event)">
    </app-invoice-header>
  
    @if (isLoading) {
      <div class="spinner-container">
        <div class="spinner"></div>
      </div>
    }
  
    @if (!isLoading) {
      <app-invoice-list [entries]="filteredEntries" [period]="period" [grandTotal]="grandTotal"></app-invoice-list>
    }
  </div>
  